import { Item } from '@src/components/Header/MenuItem'
import { EASYBIB, SiteConfig, SiteState } from '@src/state/site/types'
import { NavRoute } from './routes'
import { menuItems } from './routes'

export const getTopNavRoutes = (
  routes: NavRoute[],
  loggedIn: boolean | undefined,
  siteConfig: SiteConfig,
  site: SiteState
) => {
  return routes
    .filter(route => (route.requiresUser ? !!loggedIn : true))
    .filter(route => (route.requiresGuest ? !loggedIn : true))
    .filter(route => (route.requiredSite ? site === route.requiredSite : true))
    .map(route =>
      route.isCitationSite ? { ...route, href: siteConfig.cfeUrl + route.href } : route
    )
}

export const getTopLeftMenuItems = (
  routes: NavRoute[],
  loggedIn: boolean | undefined,
  siteConfig: SiteConfig,
  site: SiteState
) => {
  const navRoutes =
    site === EASYBIB ? getTopNavRoutes(routes, loggedIn, siteConfig, site) : []

  const topMenuItems = navRoutes.map((route, index) => {
    return {
      ...route,
      id: index * -1,
      icon: '',
      hideOnMedium: true,
    } as Item
  })

  return topMenuItems.concat(menuItems)
}



// WEBPACK FOOTER //
// ./src/components/Header/utils.tsx